module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padre"
  }, [_vm._m(0), _c('div', {
    staticClass: "display-flex fdc"
  }, [(_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "rrhh display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showCantidadPermisosSinAprobarRRHH) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('permisos-aprobar-rrhh')
      }
    }
  }, [_c('cantidad-permisos-sin-aprobar-rrhh', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadPermisosSinAprobarRRHH')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadContratosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('reporte-contratos', true)
      }
    }
  }, [_c('cantidad-contratos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadContratosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadDocumentosSinFirmar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('reporte-documentos-firmar', true)
      }
    }
  }, [_c('cantidad-documentos-sin-firmar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadDocumentosSinFirmar')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadBoletasSinVisualizar) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('boletas-reporte', true)
      }
    }
  }, [_c('cantidad-boletas-sin-visualizar', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadBoletasSinVisualizar')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), (_vm.perfilVacaciones === 'recursos humanos') ? _c('div', {
    staticClass: "contenedor-chart"
  }, [_c('top-empleados-mas-dias-disponibles', {
    staticClass: "flex-1"
  }), _c('cantidad-solicitudes-v-pendiente-aprobar-jefe', {
    staticClass: "flex-1"
  })], 1) : _vm._e(), (_vm.perfilVacaciones === 'recursos humanos') ? [_c('empleados-por-areas', {
    staticClass: "flex-1",
    attrs: {
      "isHorizontal": true
    }
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("KPIs de recursos humanos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d26762","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Dashboard_KPI.vue
// module id = 860
// module chunks = 0